/*
 * Public API Surface of ngx-lib/form
 */
export * from './form.module';
export * from './form.component';
